import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuditComponent extends BaseComponent {

  public title = 'View Audit Details';
  details: string;

  constructor(public dialogRef: MatDialogRef<AuditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data){
      this.details = JSON.parse(data.details);
    }
  }
}
